import {
    rewardsApplicationLoggerToken,
    rewardsAuthApiClientToken,
} from "@apps/rewards/tokens";
import { JsonMimeType } from "@lib/ApiClient";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, catchError, tap } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

@singleton()
class RewardsReferralContextApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface,
        @inject(rewardsApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    setReferralContext(params: {
        referralContext: string;
    }): Observable<unknown> {
        this.logger.debug(
            "RewardsReferralContextApiService.setReferralContext is started"
        );

        return this.apiClient
            .post({
                url: "/referral/setReferralContext",
                body: JSON.stringify(params),
                responseType: "text",
                contentType: JsonMimeType,
            })
            .pipe(
                catchError((error: unknown) => {
                    this.logger.debug(
                        "RewardsReferralContextApiService.setReferralContext is errored",
                        { params, error }
                    );

                    throw error;
                }),
                tap(() => {
                    this.logger.debug(
                        "RewardsReferralContextApiService.setReferralContext is ready",
                        params
                    );
                })
            );
    }
}

export default RewardsReferralContextApiService;
